"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationsFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M22.52 3.06c-3.63 0-6 1.58-7 4.52a9.12 9.12 0 011.72 1.36c.54-2.62 2.24-3.88 5.29-3.88C26.27 5.06 28 6.93 28 11c0 4.41-3.89 9-5.5 10.67a27.24 27.24 0 01-2.59-3.17 16.36 16.36 0 01-.55 2.61 28 28 0 002.46 2.71l.68.63.68-.63C23.48 23.53 30 17.37 30 11c0-5.13-2.64-7.94-7.48-7.94zM9.52 9.06C4.68 9.06 2 11.87 2 17c0 6.4 6.54 12.56 6.82 12.82l.68.63.68-.63C10.48 29.53 17 23.37 17 17c0-5.13-2.64-7.94-7.48-7.94zm3 8a3 3 0 11-3-3A3 3 0 0112.5 17z" }),
        React.createElement("path", { d: "M22.52 14.49A3.48 3.48 0 1126 11a3.48 3.48 0 01-3.48 3.49zm0-5A1.48 1.48 0 1024 11a1.48 1.48 0 00-1.48-1.47z" })));
}
exports.default = SvgLocationsFilled;
//# sourceMappingURL=LocationsFilled.js.map